import { getMCToken } from '../../../Utils/Utils';
import { WebService, WebServiceTypes } from 'minecraft-net-core-services';

export const getRealmsCheckHeaders = () => ({
  authorization: getMCToken(),
  ['X-MojangAuth']: WebService.getAuthToken(WebServiceTypes.MinecraftAuthToken.Bearer),
  applicationType: 'Java',
  microsoftPurchasingToken: WebService.getAuthToken(WebServiceTypes.MinecraftAuthToken.Marketplace)
});

export const manageRealmsLink = 'https://accounts.microsoft.com/services';

export const legacyUser = 'Legacy';

export const bedrockEntitlementKey = 'product_minecraft_bedrock';
export const javaEntitlementKey = 'product_minecraft';
